export const uploadErrors = (data ) => dispatch => {

    dispatch({
        type: "UPLOAD_ERROR",
        data
    });
}

export const initializeUpload = (data ) => dispatch => {

    dispatch({
        type: "UPLOAD_INIT",
        data
    });
}


// WEBPACK FOOTER //
// ./src/actions/upload.js